export const enum LiveStreamComponent {
  HLS = 'hls',
  YOUTUBE = 'youTube',
  TWITCH = 'twitch',
  IMG = 'img',
}

export const LIVE_STREAM_TYPES = {
  0: LiveStreamComponent.HLS,
  1: LiveStreamComponent.YOUTUBE,
  2: LiveStreamComponent.TWITCH,
  3: LiveStreamComponent.IMG,
};
